import Vue from 'vue';
import Vuetify, { VBadge } from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css';
import PinIcon from '@/components/Common/CustomIcons/PinIcon.vue';
import PdfIcon from '@/components/Common/CustomIcons/PdfIcon.vue';
import LodgeIcon from '@/components/Common/CustomIcons/LodgeIcon.vue'
import ShowContractIcon from '@/components/Common/CustomIcons/ShowContractIcon.vue'
import SendReportIcon from '@/components/Common/CustomIcons/SendReportIcon.vue'
import ViewReportIcon from '@/components/Common/CustomIcons/ViewReportIcon.vue'
import FileExcelIcon from '@/components/Common/CustomIcons/FileExcelIcon.vue'

Vue.use(Vuetify, {components: { VBadge, PinIcon, PdfIcon }});

export default new Vuetify({
  // FIXME: Defining the theme here doesn't scale very well; if this gets too big we should explore
  // other options.
  theme: {
    themes: {
      light: {
        primary: '#2850a0',        
        secondary: '#9e9e9e',
        accent: '2aabe2',
        lightblue: '#4D8AD0', 
        brick: '#d14836'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
    values: { 
      pin: {
        component: PinIcon
      },
      pdf: {
        component: PdfIcon
      },
      lodgeicon: {
        component: LodgeIcon
      },
      showcontracticon: { 
        component: ShowContractIcon
      },
      sendreporticon: {
        component: SendReportIcon
      },
      viewreporticon: {
        component: ViewReportIcon
      },
      fileexcelicon: {
        component: FileExcelIcon
      }
    }
  },
});
